import { XIcon } from "lucide-react";
import { useTranslations } from "translations";
import { Button } from "../button/button";

export type DateClearButtonProps = {
  id?: string;
  onClear: () => void;
};

// Shared clear affordance for date inputs. HeroUI's `end` slot on the pickers is
// the calendar toggle button, so consumers render this in the raw `start` slot
// and rely on `order-last` to keep it at the end next to the calendar. Styling
// mirrors the calendar selector icon (gray-900, 2px stroke).
export function DateClearButton({ id, onClear }: DateClearButtonProps) {
  const translations = useTranslations();

  return (
    <Button
      aria-label={translations.actions.clearDate}
      className="order-last rounded-full text-gray-900! [&>svg]:stroke-lg!"
      id={id ?? "date-clear"}
      isIconOnly
      size="sm"
      variant="light"
      onPress={onClear}
    >
      <XIcon size={16} />
    </Button>
  );
}
